<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SecurityProviderGrid @selectedSecurityProvider="objRowSelected = $event"></SecurityProviderGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <!-- Line 01 -->
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="security_provider_provider_name">provider name</label>
            <input
              type="text"
              class="form-control text-uppercase"
              id="security_provider_provider_name"
              v-model.trim="objItem.provider_name"
            />
          </div>

          <div class="form-group col-md-6">
            <label for="security_provider_type_id">security provider type</label>
            <b-form-select
              id="security_provider_type_id"
              :options="providerType"
              v-model="objItem.security_provider_type_id"
            />
          </div>

          <!--- SECURITY PROVIDER DATA --->
          <!-- STREAMLINE ONLY -->
          <div
            id="streamline_only"
            class="wt-sub-form"
            v-if="objItem.security_provider_type_id === 'STREAMLINE'"
          >
            <div class="form-group col-md-6 px-2">
              <label for="security_provider_recycle_secret_key_days">recycle secret key days</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_recycle_secret_key_days"
                v-model.trim="objItemData.recycle_secret_key_days"
              />
            </div>
          </div>

          <!-- CUSTOM ONLY -->
          <div
            id="custom_only"
            class="wt-sub-form"
            v-if="objItem.security_provider_type_id === 'CUSTOM'"
          >
            <div class="form-group col-md-6 px-2">
              <label for="security_provider_url">URL</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_url"
                v-model.trim="objItemData.url"
              />
            </div>
          </div>

          <!-- ACTIVE_DIRECTORY ONLY -->
          <div
            id="active_directory_only"
            class="wt-sub-form"
            v-if="objItem.security_provider_type_id === 'ACTIVE_DIRECTORY'"
          >
            <div class="form-group col-md-6 px-2">
              <label for="security_provider_server">Server</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_server"
                v-model.trim="objItemData.server"
              />
            </div>

            <div class="form-group col-md-6 px-2">
              <label for="security_provider_port">Port</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_port"
                v-model.trim="objItemData.port"
              />
            </div>

            <div class="form-group col-md-6 px-2">
              <label for="security_provider_user_name">User</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_user_name"
                v-model.trim="objItemData.user_name"
              />
            </div>

            <div class="form-group col-md-6 px-2">
              <label for="security_provider_password">Password</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_password"
                v-model.trim="objItemData.password"
              />
            </div>

            <div class="form-group col-md-6 px-2">
              <label for="security_provider_root_dn">Root DN</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_root_dn"
                v-model.trim="objItemData.root_dn"
              />
            </div>

            <div class="form-group col-md-6 px-2">
              <label for="security_provider_ldap_search_filter">LDAP Search Filter</label>
              <input
                type="text"
                class="form-control"
                id="security_provider_ldap_search_filter"
                v-model.trim="objItemData.ldap_search_filter"
              />
            </div>
          </div>
        </div>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import SecurityProviderGrid from "./SecurityProviderGrid";

export default {
  name: "SecurityProvider",
  props: {
    providerType: Array
  },

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, SecurityProviderGrid },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "security-ds/api/internal/security-provider",
      primary_key: "security_provider_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "security_provider_data",
      requiredEndDt: false,
      noDelete: true

      /* Others Query */
      //providerType: [{ value: null, text: "..." }]
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
      });
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("securityProviderSelected", null);
        } else {
          this.$emit("securityProviderSelected", this.objSelected.access_key);
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    }
  }
};
</script>